import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@icon/continuous-sprint.svg'
import _imports_1 from '@icon/zero-sprint.svg'


const _hoisted_1 = { class: "sprint-label is-flex" }
const _hoisted_2 = { class: "sprint-label__marker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.sprint.continuousSprint)
        ? (_openBlock(), _createBlock(_component_icon, {
            key: 0,
            data: _imports_0,
            class: _normalizeClass(["continuous-sprint__icon", [`is-${_ctx.sprint.status.toLowerCase()}`]]),
            fill: true,
            width: _ctx.iconSize,
            height: _ctx.iconSize
          }, null, 8, ["class", "width", "height"]))
        : (_ctx.sprint.zeroSprint)
          ? (_openBlock(), _createBlock(_component_icon, {
              key: 1,
              data: _imports_1,
              class: _normalizeClass(["zero-sprint__icon", [`is-${_ctx.sprint.status.toLowerCase()}`]]),
              fill: true,
              width: _ctx.iconSize,
              height: _ctx.iconSize
            }, null, 8, ["class", "width", "height"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["dot dot_sm", [`is-${_ctx.sprint.status.toLowerCase()}`]])
            }, null, 2))
    ]),
    _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
  ]))
}